import { defineMessages } from "react-intl";

export default defineMessages({
  waitingForBankTransfer: {
    id: "confirmationModal.waitingForBankTransfer",
    defaultMessage: "Waiting for bank transfer",
  },
  paymentConfirmed: {
    id: "confirmationModal.paymentConfirmed",
    defaultMessage: "Payment confirmed",
  },
  paymentConfirmedInformations: {
    id: "confirmationModal.paymentConfirmedInformations",
    defaultMessage:
      "Last thing - help { serviceProviderName } by giving your feedback on this service",
  },
  continue: {
    id: "confirmationModal.continue",
    defaultMessage: "Continue",
  },
});
